<template>
  <div
    style="padding: 0.875rem 1rem; background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 0.625rem; transition: box-shadow 0.15s ease, border-color 0.15s ease; overflow: hidden; min-width: 0;"
    @mouseover="$event.currentTarget.style.borderColor='#FBCFE8'; $event.currentTarget.style.boxShadow='0 2px 8px rgba(236, 72, 153, 0.08)'"
    @mouseout="$event.currentTarget.style.borderColor='#E5E7EB'; $event.currentTarget.style.boxShadow='none'"
  >
    <!-- Label + info -->
    <div style="display: flex; align-items: center; gap: 0.375rem; margin-bottom: 0.5rem;">
      <span style="font-size: 0.75rem; font-weight: 500; color: #6B7280; line-height: 1.3;">{{ item.name }}</span>
      <span v-if="item.info" v-tooltip="{ content: item.info }" style="display: inline-flex; align-items: center; cursor: help; flex-shrink: 0;">
        <svg xmlns="http://www.w3.org/2000/svg" style="width: 0.875rem; height: 0.875rem; color: #D1D5DB;" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </span>
    </div>

    <!-- Value -->
    <div style="font-size: 1.375rem; font-weight: 700; color: #111827; line-height: 1.2; word-break: break-word;">{{ item.stat }}</div>

    <!-- Change indicator (own line) -->
    <div v-if="item.changeType !== null && item.change" style="margin-top: 0.375rem;">
      <span :style="{ display: 'inline-flex', alignItems: 'center', gap: '0.125rem', fontSize: '0.75rem', fontWeight: 600, color: item.changeType === 'increase' ? '#059669' : '#DC2626' }">
        <svg v-if="item.changeType === 'increase'" xmlns="http://www.w3.org/2000/svg" style="width: 0.75rem; height: 0.75rem; flex-shrink: 0;" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
        </svg>
        <svg v-else-if="item.changeType === 'decrease'" xmlns="http://www.w3.org/2000/svg" style="width: 0.75rem; height: 0.75rem; flex-shrink: 0;" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
        {{ item.change }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: null,
  },
}
</script>
